module.exports = __webpack_public_path__ + "img/solana.ac43c55a.jpeg";